<div class="modal-header">
	<h5 class="modal-title">Inloggen op {{systemTitle}}</h5>
	<button type="button" class="close" aria-label="Close" (click)="close()">
		<span aria-hidden="true">&times;</span>
	</button>
</div>

<div class="modal-body p-5" style="max-width: 500px;">
	<div class="alert alert-danger" role="alert" *ngIf="error">
		<div *ngIf="errorCode == 'USER_NOT_ACTIVE'">
			{{errorMessage}}
		</div>
		<div *ngIf="errorCode == 'WRONG_AUTHENTICATION'">
			Het opgegeven wachtwoord is niet juist. <a (click)="goToPasswordReset()" class="text-primary">Stel hier je
				wachtwoord opnieuw in.</a>
		</div>
	</div>

	<div class="alert alert-warning" role="alert" *ngIf="warning">
		<div *ngIf="errorCode == 'USER_NOT_EXIST'">
			{{errorMessage}} <a class="underscore" (click)="showRegister()">Of moet jij je eerst nog registreren?</a>
		</div>
	</div>

	<div class="alert alert-success" *ngIf="passwordResetSuccess">Er is een e-mail naar <em>{{email}}</em> onderweg met
		een link om je wachtwoord opnieuw in te stellen.</div>

	<div class="content-preview-container" *ngIf="isContentPreview">
		<div>
			<h2>Je bent niet ingelogd</h2>
			<p>Dit betekent dat je geen opdrachten kunt maken en dat je ook niet de hele les kunt bekijken.</p>
			<div id="preview-options">
				<button type="submit" class="btn btn-primary" (click)="close()">Doorgaan zonder inloggen</button>
				<button type="submit" class="btn btn-success"
					(click)="isContentPreview = !isContentPreview">Inloggen</button>
			</div>

			<a id="trialLink" href="https://over.{{systemKey}}.nl/proeflicentie" target="_blank">
				<div id="trialBanner">
					<div id="content">
						<img width="65px" [src]="''+cdnUrl+'images/artwork/'+systemKey+'/logo-ipad.svg'"
							class="img-fluid" alt="{{systemTitle}}" />

						<div>
							<b>{{systemTitle}} gratis proberen?</b>
							<p>Vraag hier een proeflicentie aan</p>
						</div>
					</div>
					<i class="fa-solid fa-caret-right"></i>
				</div>
			</a>
		</div>
	</div>

	<div class="login-container" *ngIf="!isContentPreview">
		<div class="login-inner" [ngClass]="{'displayNone': passwordResetSuccess}">
			<div class="form-group">
				<div (click)="loginMethod == 'PASSWORD' && resetLogin()">
					<label for="email" [ngClass]="{'hidden' : loginMethod == 'PASSWORD'}">Vul hier je e-mailadres
						in</label>
					<input type="text" id="email" (keyup.enter)="confirm()"
						[ngClass]="{ 'is-invalid': errorEmailRequired || errorInvalidEmail || errorInvalidEmailTld , 'is-valid': emailValid }"
						[(ngModel)]="email" (change)="filterEmailSpaces($event)" placeholder="mijn@emailadres.nl"
						class="form-control" (click)="resetValidation();" />
					<div *ngIf="errorInvalidEmail || errorInvalidEmailTld" class="invalid-feedback">
						Dit lijkt geen echt e-mailadres
					</div>
				</div>
				<div *ngIf="errorEmailRequired" class="invalid-feedback">
					Je e-mailadres is verplicht.
				</div>
				<div *ngIf="errorInvalidEmail" class="invalid-feedback">
					Dit lijkt geen echt e-mailadres te zijn, kijk eens goed.
				</div>
				<div *ngIf="errorInvalidEmailTld" class="invalid-feedback">
					Het lijkt erop dat je een ongeldige domeinnaam hebt ingevoerd. Een e-mailadres eindigt op
					.{{allowedTld.join(', .')}}.
				</div>
			</div>
			<div class="form-group" [ngClass]="{'unavailable' : loginMethod != 'PASSWORD'}">
				<label for="password">Vul hier je wachtwoord in</label>
				<input type="password" id="password" autocomplete="current-password" (keyup.enter)="confirm()"
					[(ngModel)]="password" (keyup)="resetValidation()" [ngClass]="{ 'is-invalid': error}"
					class="form-control" />
				<!-- <div *ngIf="errorPasswordRequired" class="invalid-feedback">
					Je wachtwoord is verplicht.
				</div> -->
				<div *ngIf="errorInvalidPassword" class="invalid-feedback">
					Dit lijkt geen kloppend wachtwoord te zijn, kijk eens goed.
				</div>
			</div>
			<div class="form-group unavailable" [ngClass]="{'unavailable' : loginMethod != null}">
				<!-- <button type="button" (click)="filterEmailSpaces(null)" class="btn btn-success"
					[disabled]="!validateEmail(email) || error || warning">Verder</button> -->
				<a [ngClass]="{'disabled' : !validateEmail(email) || error || warning}"
					(click)="filterEmailSpaces(null)" href="javascript:;" class="btn btn-info mx-1 mx-md-3 loginButton"
					style="margin-left: 0 !important; color: white;">Verder</a>
			</div>
			<div class="form-group flex justify-space-between unavailable" [ngClass]
				[ngClass]="{'unavailable' : loginMethod != 'PASSWORD'}">
				<button type="submit" (click)="confirm()" class="btn btn-success"
					[disabled]="password.length < 1 || error || warning">Inloggen</button>

				<span (click)="resetPassword()" class="btn btn-info">Wachtwoord vergeten?</span>
			</div>
			<div class="form-group unavailable" [ngClass]="{'unavailable' : loginMethod != 'ENTREE'}">
				<a href="{{baseUrl}}auth/authentication/entree" class="btn btn-success">Inloggen met Entree</a>
			</div>
		</div>
		<div style="display: flex; align-items: center; justify-content: space-between; margin-top: 25px;">
			<a class="underscore" (click)="showRegister()">Registreren</a>
			<a href="https://uitgeverijneo.nl/files/privacybeleid.pdf" target="_blank">Privacybeleid</a>
		</div>
	</div>
</div>